import { Grid } from "@mui/material"
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import { datesNameToNum } from "../../helpers/dateHelpers";
import DbmInfo from "../../models/DbmInfo";
import { useFreezePeriod } from "../../providers/FreezePeriod";

export default function DbmMbgLinks({dbmInfo={} as DbmInfo, searchState}) {
    const { t } = useTranslation();
    const pairingFreezeContext = useFreezePeriod();
    const [freezeStatus, setFreezeStatus] = useState('');

    useEffect(() => {
      if (!pairingFreezeContext.freezePeriodData.pairingFreeze.length) {
        return;
      }
      let d = searchState.selectedDate.split(' ');
      let month = datesNameToNum(d[0]);
      let matchedPairings = pairingFreezeContext.freezePeriodData.pairingFreeze.filter(f => f.pairingMonth === month);
      if (!matchedPairings.length) {
        setFreezeStatus('pairingPackage.stautsBiddingClosed');
        return;
      }
      // let status = freezePeriod(matchedPairings[matchedPairings.length - 1]);
      // setFreezeStatus(status as string);
      let freezeStatusFromApi = pairingFreezeContext.freezePeriodData.pairingFreeze[0]?.pairingStatus || 'noData'
      setFreezeStatus(t(`pairingStatus.${freezeStatusFromApi}`));
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchState.toSelectDate, pairingFreezeContext.freezePeriodData.pairingFreeze])


    // freezePeriodData.
    return (
        <Grid item className='left-block'>
            <span>{t('pairingList.lastUpdate')}: {format(new Date(), 'MMM dd')}</span>
            <span>{t('pairingList.status')}: {t(freezeStatus)} </span>
            <div className='dbm-mbg'>
                <Link to='/dbm'>{t('pairingList.dbm')} = {String(dbmInfo.dbm)}</Link>
                <Link to='/dbm'>{t('pairingList.mbg')} = {String(dbmInfo.mbg)}</Link>
            </div>
        </Grid>
    );
}

